<!-- <div class="modal">
    <h1 class="modal-title forgot-title">{{ 'account.forgot.title' | translate }}</h1>
    <p class="instructions">{{ 'account.forgot.subtitle' | translate }}<br>
        {{ 'account.forgot.instruction' | translate }}
    </p>
    <input class="input" [(ngModel)]="email" type="text" (input)="verifyEmail()"
        [placeholder]="'account.forgot.insert' | translate" required>
    <div class="not-match" *ngIf="errorHint">
        {{ 'account.forgot.hint.invalidEmail' | translate }}
    </div>
    <div class="buttons no-margin">
        <button mat-flat-button class="btn outlined" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
        <button mat-flat-button class="btn default" (click)="send()" [disabled]="!email || errorHint || loading">{{ 'button.send' | translate }}</button>
    </div>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner> -->

<div class="int-card reset-card">
    <mat-card>
        <form>
            <img (click)="cancel()" class="arrow-left" src="/assets/account/arrow-left.svg" />
            <h1 *ngIf="!isReseting" class="title-forgot">
                {{ 'account.forgot.title' | translate }}
            </h1>
            <h1 *ngIf="isReseting" class="title-forgot">
                {{ 'account.reset.title' | translate }}
            </h1>
            <div class="subtitle-forgot">
                <p *ngIf="!isReseting">{{ 'account.forgot.subtitle' | translate }}</p>
                <p>{{ 'account.forgot.instruction' | translate }}</p>
            </div>
            <div class="card-form">
                <input class="input" [(ngModel)]="email"  [ngModelOptions]="{standalone: true}" type="text" (input)="verifyEmail()"
                    [placeholder]="'account.forgot.insert' | translate" required>
                <div class="not-match" *ngIf="errorHint">
                    {{ 'account.forgot.hint.invalidEmail' | translate }}
                </div>
                <!-- <mat-form-field [hideRequiredMarker]="true" appearance="fill">
                    <mat-label>
                        {{ 'account.forgot.details' | translate }}
                    </mat-label>
                    <input matInput type="text" required [(ngModel)]="user" [ngModelOptions]="{standalone: true}"/>
                    <div class="hint" *ngIf="errorHint">{{'account.login.notFoundUser' | translate }}</div>
                </mat-form-field> -->
                <div class="buttons no-margin">
                    <button class="btn default forgot-button" (click)="send()" [disabled]="!email || errorHint || loading">
                        {{ 'button.send' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </mat-card>
    <mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>